import React, { useEffect, useState } from 'react'
import { deleteSifarishData, getUserSifarish } from '_services';
import { ButtonHeading, CommonModal } from 'components';
import BootstrapTable from 'components/BootstrapTable';
import toast from 'react-hot-toast';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FaRegTrashCan } from 'react-icons/fa6';
import { FiEdit } from 'react-icons/fi';
import { Link, useNavigate, useParams } from 'react-router-dom';
import MastersFilterModal from "modals/MastersFilterModal";
import { AiOutlineEye } from 'react-icons/ai';
import { Images } from 'constants';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { utils } from 'helper';
import moment from "moment";

const UserSifarishs = () => {

  const params = useParams();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const getUserData = JSON.parse(localStorage.getItem('userData'));
  const [sifarishData, setSifarishData] = useState();
  const [isDelete, setIsDelete] = useState(false);
  const navigate = useNavigate();

  const itemsPerPage = 10;
  const [totalCount, setTotalCount] = useState(0);

  const [selectedRange, setSelectedRange] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  });


  const [filter, setFilter] = useState({
    userId: '',
    page: 1,
    limit: 10,
    categoryIds: '',
    subCategoryId: '',
    birdId: '',
    startDate: null,
    endDate: null,
  });


  useEffect(() => {
    fetchUserSifarish(params);
  }, [params, filter]);


  const handleDelete = (item) => {
    setIsDelete(item);
  };


  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, page: page }));
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const currentPage = filter.page;
    let pages = [];
    const createPageItem = (i) => (
      <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
        <a className="page-link _avPointer" onClick={() => handlePageChange(i)}>
          {i}
        </a>
      </li>
    );

    const rangeStart = Math.max(2, currentPage - 2);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 2);

    pages.push(createPageItem(1));

    if (rangeStart > 2) {
      pages.push(
        <li key="dots-before" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(createPageItem(i));
    }

    if (rangeEnd < totalPages - 1) {
      pages.push(
        <li key="dots-after" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (totalPages > 1) {
      pages.push(createPageItem(totalPages));
    }

    return (
      <ul className="pagination ">
        <li className={`page-item ${filter?.page === 1 ? "disabled" : ""}`}>
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter?.page - 1)}
          >
            <IoChevronBack />
          </a>
        </li>
        {pages}
        <li
          className={`page-item ${filter?.page === totalPages ? "disabled" : ""
            }`}
        >
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter?.page + 1)}
          >
            <IoChevronForward />
          </a>
        </li>
      </ul>
    );
  };

  const fetchUserSifarish = async (data) => {
    try {
      const payload = {
        ...filter,
        userId: data?.userId,
        createdByUserId: data?.createdByUserId,
        categoryIds: filter?.categoryIds ? [filter?.categoryIds] : [],
        subCategoryId: filter?.subCategoryId ? [filter?.subCategoryId] : [],
        startDate: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        endDate: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        // birdId: data?.birdId,
      };

      const res = await getUserSifarish(payload);
      // console.log('created_user', res)
      if (res) {
        setTotalCount(res?.data?.totalRecords);
        setSifarishData(res?.data);
        // console.log('ffffff',)
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const columns = [
    { header: "", accessor: "serial" },
    { header: "User", accessor: "userName" },
    { header: "Title ", accessor: "title" },
    { header: "Category ", accessor: "category" },
    { header: "SubCategories", accessor: "subCategories" },
    { header: "Sifarish Image", accessor: "sifarishImage" },
    { header: "City", accessor: "city" },
    { header: "State", accessor: "state" },
    { header: "Country", accessor: "country" },
  ];

  const handleDetailPage = (sifarishId) => {
    if (!sifarishId) return;
    navigate(`/sifarish/getSifarishes?userId=${getUserData?._id}&sifarishId=${sifarishId}`);
  };

  const rowListData = (data) => {
    return data?.map((item) => ({
      ...item,
      serial: (
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              <Link
                onClick={() => item?._id && handleDetailPage(item._id)}
                // to={`/user/details/${item?._id}`}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <AiOutlineEye />
                  </span>
                  &nbsp; View
                </span>
              </Link>

              <Link className="_avPointer" style={{ textDecoration: "none" }}>
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <FiEdit />
                  </span>
                  &nbsp; Edit
                </span>
              </Link>

              <div
                className="_avPointer"
                onClick={() => handleDelete(item)}
              >
                <span className="_samAnchor">
                  <span className="deleteIcon_avt">
                    <FaRegTrashCan color="red" />
                  </span>
                  Delete
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
      userName: (
        <React.Fragment>
          <div onClick={() => item?._id && handleDetailPage(item._id)} className='__userPro'>
            <img src={item?.createdByUserId?.userProfileImageUrl || Images.USERLIMG} alt="user Img" style={{ borderRadius: '50%' }} width={30} height={30} />
            <span>{`${item?.createdByUserId?.firstName || "-"} ${item?.createdByUserId?.lastName || "-"}`}</span>
          </div>
        </React.Fragment>
      ),

      title: (
        <React.Fragment>
          <div className='__anvDots' title={item?.title}>{item?.title || "-"}</div>
        </React.Fragment>
      ),

      category: (
        <React.Fragment>
          {item?.categoryId?.title || "-"}
        </React.Fragment>
      ),

      subCategories: (
        <React.Fragment>
          {item?.categoryId?.subCategories?.length > 0 ? (
            item.categoryId.subCategories
              .filter(sub => sub._id === item.subCategoryId)
              .map((sub) => (
                <span key={sub._id}>{sub.title}</span>
              ))
          ) : (
            "No Subcategory Available"
          )}

          {/* {item?.categoryId?.subCategories?.length > 0 ? (
            item.categoryId.subCategories.map((sub, index) => (
              <span key={sub._id}>
                {sub.title}
                {index !== item.categoryId.subCategories.length - 1 ? ", " : ""}
              </span>
            ))
          ) : (
            "No Subcategories Available"
          )} */}
        </React.Fragment>
      ),

      sifarishImage: (
        <React.Fragment>
          {item.mediaUrls.length > 0 ? (
            <div className='__imgMedia'>
              <img
                src={item.mediaUrls[0]?.url || "https://via.placeholder.com/400x300"}
                alt={`Sifarish_${item.mediaUrls.length}`}
                width={40}
                height={30}
                className="_slidImg"
              />
            </div>
          ) : (
            <p>No Image Available</p>
          )}
        </React.Fragment>
      ),

      city: (
        <React.Fragment>
          {item?.address?.city || "-"}
        </React.Fragment>
      ),

      state: (
        <React.Fragment>
          {item?.address?.state || "-"}
        </React.Fragment>
      ),

      country: (
        <React.Fragment>
          {item?.address?.country || "-"}
        </React.Fragment>
      ),

    }));
  };

  const exportToCSV = () => {
    if (!sifarishData || sifarishData?.sifarishes?.length === 0) {
      toast.error("No data to export!");
      return;
    }

    const csvHeaders = [
      "Serial No", "User", "Title", "Category", "SubCategories", "Sifarish Image", "City", "State", "Country"
    ];

    const csvRows = sifarishData?.sifarishes.map((item, index) => [
      index + 1,
      `${item?.createdByUserId?.firstName || "-"} ${item?.createdByUserId?.lastName || "-"}`,
      item?.title || "-",
      item?.categoryId?.title || "-",
      item?.categoryId?.subCategories?.map(sub => sub.title).join(", ") || "No Subcategories Available",
      item.mediaUrls.length > 0 ? item.mediaUrls[0]?.url : "No Image Available",
      item?.address?.city || "-",
      item?.address?.state || "-",
      item?.address?.country || "-"
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [csvHeaders.join(","), ...csvRows.map(row => row.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.href = encodedUri;
    link.download = "Sifarish_List.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const submitDeleteUser = async () => {
    const payload = {
      userId: getUserData?._id,
      sifarishId: isDelete?._id,
    };
    try {
      const res = await deleteSifarishData(payload);
      if (!!res) {
        fetchUserSifarish(getUserData?._id);
        setIsDelete(false);
        toast.success(res?.message);
      } else {
        toast.error("Error !! ");
      }
    } catch (error) {
      throw error;
    }
  };


  let propsDelete = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: submitDeleteUser,
    // isLoadding: loading,
  };

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((s) => ({ 
      ...s, 
      page: 1,
      startDate: newRange.startDate,
      endDate: newRange.endDate,
     }));
  };
  return (
    <>
      <ButtonHeading
        title={"Users Sifarishes"}
        Export={true}
        ExportSubmit={exportToCSV}
        showDateRange={true}
        selectedRange={selectedRange}
        handleApply={handleApply}
        setFilter={setFilter}
        showSearchFilter={{ filterOption: false, filterCount: true }}
        filter={filter}
        isShow={{
          category: true,
          subcategory: true,
          // birds: true,
          // search: true,
        }}
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(sifarishData?.sifarishes?.length > 0 ? sifarishData?.sifarishes : [])}
        // isLoading={loading}
        />

        <div className="paginationFt_avt">{renderPagination()}</div>
      </div>

      <CommonModal {...propsDelete}>
        <p className="p-3">
          Are you sure you want to delete this Sifarish ?
        </p>
      </CommonModal>
    </>
  )
}

export default UserSifarishs